import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { Button } from "semantic-ui-react";
import { initialFavoriteArtistFilter } from "./FilterTypes/FavoriteArtistFilterType";
import { FilterContext } from "../FilterContext";

const FavoriteArtistsFilter = () => {
  const title = RESX.GeneralLabels.Favorite;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);

  register("favoriteArtists", {
    getTitle: () => title,
    renderSelection: (filter) => <>
      {filter.onlyFavorite && RESX.GeneralLabels.OnlyFavorites}
    </>,
    hasValue: (filter) => filter.onlyFavorite,
    reset: () => ({
      onlyFavorite: false
    }),
    areEqual: (a, b) => a.onlyFavorite === b.onlyFavorite
  });
  useEffect(() => {
    setInitialValue("favoriteArtists", initialFavoriteArtistFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [onlyFavorite, setOnlyFavorite] = React.useState<boolean>(initialFavoriteArtistFilter.onlyFavorite);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setOnlyFavorite(getValue("favoriteArtists").onlyFavorite);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("favoriteArtists", { onlyFavorite });
    setPopupOpen(false);
  };

  const options = [
    { value: true, label: RESX.GeneralLabels.OnlyFavorites },
    { value: false, label: "All" }
  ];
  type Option = typeof options[number];

  const onChange = (option: Option) => {
    setOnlyFavorite(option.value);
    setValue("favoriteArtists", { onlyFavorite: option.value });
    onPopupClose();
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<form onSubmit={onApply}>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            noScrolling
            items={options}
            selectedItems={onlyFavorite ? [options[0]] : [options[1]]}
            onItemToggled={onChange}
            getId={opt => opt.value.toString()}
            getName={opt => opt.label}
          />
        </div>

        <Button fluid type="submit" primary >
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default FavoriteArtistsFilter;